import ruAuth from './locales/ru/auth.json'
import ruAccount from './locales/ru/account.json'
import ruCart from './locales/ru/cart.json'
import ruCheckout from './locales/ru/checkout.json'
import ruStores from './locales/ru/stores.json'
import uzAccount from './locales/uz/account.json'
import uzCart from './locales/uz/cart.json'
import uzCheckout from './locales/uz/checkout.json'
import uzStores from './locales/uz/stores.json'
import ruCatalog from './locales/ru/catalog.json'
import ruCommon from './locales/ru/common.json'
import ruErrors from './locales/ru/errors.json'
import ruHome from './locales/ru/home.json'
import uzAuth from './locales/uz/auth.json'
import uzCatalog from './locales/uz/catalog.json'
import uzCommon from './locales/uz/common.json'
import uzErrors from './locales/uz/errors.json'
import uzHome from './locales/uz/home.json'

export const NAMESPACES = [
  'common',
  'errors',
  'auth',
  'home',
  'catalog',
  'cart',
  'checkout',
  'account',
  'stores',
] as const

export type Namespace = (typeof NAMESPACES)[number]

export const resources = {
  ru: {
    common: ruCommon,
    errors: ruErrors,
    auth: ruAuth,
    home: ruHome,
    catalog: ruCatalog,
    cart: ruCart,
    checkout: ruCheckout,
    account: ruAccount,
    stores: ruStores,
  },
  uz: {
    common: uzCommon,
    errors: uzErrors,
    auth: uzAuth,
    home: uzHome,
    catalog: uzCatalog,
    cart: uzCart,
    checkout: uzCheckout,
    account: uzAccount,
    stores: uzStores,
  },
} as const
